export function llmRunGetPageUrl(runId: string): string {
  return `/llmRuns/${runId}`;
}
